module.exports = __webpack_public_path__ + "img/circle_grey_arrow_left.cf32becd.png";